import React from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'
// const data = [{ value: 50 }, { value: 100 }]
const COLORS = ['', '#dadada']

const PieHollow = ({ val1, val2 }) => {
    //calculate percentage
    let percent = 0;
    if (!isNaN(val1) && !isNaN(val2) && val1 > 0 && val2 > 0) {
        percent = Math.floor((val1 / val2) * 100)
    }

    percent = percent > 100 ? 100 : percent
    COLORS[0] = percent < 50 ? '#ff3333' : '#00C49F'
    const data = [{ value: percent }, { value: 100 - percent }]
    
    return (
        <ResponsiveContainer>
            <PieChart>
                <Pie
                    data={[{ value: 1 }]}
                    dataKey="value"
                    outerRadius="100%"
                    innerRadius="80%"
                    fill="#8884d8"
                    legendType="none"
                    paddingAngle={0}
                    isAnimationActive={false}
                >
                    {data.map((entry, index) => (
                        <Cell key={index} strokeWidth={0} fill="#dadada" />
                    ))}
                </Pie>
                <Pie
                    data={data}
                    dataKey="value"
                    outerRadius="100%"
                    innerRadius="80%"
                    fill="#8884d8"
                    animationEasing="ease-out"
                    animationDuration={500}
                >
                    {data.map((entry, index) => (
                        <Cell
                            key={index}
                            strokeLinecap="round"
                            strokeWidth={0}
                            fill={COLORS[index % COLORS.length]}
                        />
                    ))}
                </Pie>
                <g>
                    <text
                        //x="51%"
                        //y="48%"
                        fontSize={18}
                        fontWeight={600}
                        dx="53%"
                        dy="55%"
                        textAnchor="middle"
                        fill="#000"
                    >
                        {data[0].value}%
                    </text>
                </g>
            </PieChart>
        </ResponsiveContainer>
    )
}
export default PieHollow
